import React, { useContext, useEffect } from "react";
import "../../styles/screens/screens.css";
import "../../styles/screens/general.scss";

import { Context } from "./../../provider/index";
import languageData from "../../data/language.json";

import Header from "../general/Header";
import Footer from "../general/Footer";
import Border from "../general/Border";

const ExplScreen = () => {
  const { admin, dispatch } = useContext(Context);
  const currentLanguage = admin.language;
  const textData = languageData[currentLanguage];

  useEffect(() => {
    dispatch({ type: "option", payload: 0 });
    dispatch({ type: "maxOptions", payload: 5 });
    dispatch({ type: "rulesToSwitch", payload: true });
  }, [dispatch]);

  return (
    <div className="uiContainer">
      <Header />

      <div
        className="uiField uiFieldBorders"
        style={{ width: admin.size.w, height: admin.size.h }}
      >
        {admin.option === 0 && (
          <div className="ContExpl option1">
            <h1 className="titleExpl opt1">{textData.explPage.expl1Title}</h1>
            <h1 className="titleExpl opt12">
              {textData.explPage.explsecondTitle}
            </h1>
          </div>
        )}
        {admin.option === 1 && (
          <div className="ContExpl option2">
            <h1
              className="titleExpl opt2"
              dangerouslySetInnerHTML={{ __html: textData.explPage.expl2Title }}
            />
            <img src={textData.explPage.gif2} alt="placeholder img 2"></img>
          </div>
        )}
        {admin.option === 2 && (
          <div className="ContExpl option3">
            <h1 className="titleExpl opt3">{textData.explPage.expl3Title}</h1>
            <img
              src={`./images/explScreen/expl_opt3-${currentLanguage}.png`}
              alt="placeholder img 3"
            ></img>
          </div>
        )}
        {admin.option === 3 && (
          <div className="ContExpl option4">
            <h1 className="titleExpl opt4">{textData.explPage.expl4Title}</h1>
            <img
              src="./images/gifs/expl_4.gif"
              alt="placeholder img 4"
              className="speedGif"
            ></img>
          </div>
        )}
        {admin.option === 4 && (
          <div className="ContExpl option4">
            <h1 className="titleExpl opt5">{textData.explPage.expl5Title}</h1>
            <img
              src="./images/gifs/price-6.gif"
              alt="placeholder img 5"
              className="picExpl opt5"
            ></img>
            <button className="btn opt5">{textData.welcomePage.button}</button>
          </div>
        )}
        <Border />
      </div>

      <Footer actives={[0, 1, 0, 1]} />
    </div>
  );
};

export default ExplScreen;
